import React from 'react';
import Grid from '../components/Core/Grid';
import WindowBody from '../components/Window/WindowBody';
import WindowFooter from '../components/Window/WindowFooter';
import { UiButton } from '../components/UiButton';

export default function InterCobrancaGridViewer(props: any) {
    return (
        <>
            <WindowBody noPadding>
                <Grid router="intercobranca" />
            </WindowBody>
            <WindowFooter>
                <UiButton variant="secondary" onClick={props.triggerClose}>Fechar</UiButton>
            </WindowFooter>
        </>
    );
}
